import { Loading } from 'element-ui'

var loadCounter = 0
var load_options = {
    text: "页面加载中..."
}
var elNode = null
const startLoading = function() {
    // console.log('this++++');
    // console.log(this);
    loadCounter++;
    elNode = Loading.service(load_options);
}
const endLoading = function() {
    --loadCounter;
    if (loadCounter < 1) {
        elNode.close();
    }
}
export {
    startLoading,
    endLoading
}


// WEBPACK FOOTER //
// ./src/util/loading.js